import * as React from 'react';
import { PropTypes } from 'prop-types';

function Arrow({ ...props }) {
    return (
        <svg width="21" height="32" viewBox="0 0 21 32" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M15.99 31.99L0 15.99L15.99 0L20.24 4.24L8.48 15.99L20.24 27.75L15.99 31.99Z" />
        </svg>
    );
}

Arrow.prototypes = {
    fill: PropTypes.string,
};

Arrow.defaultProps = {
    fill: '#0000FF',
};

export default Arrow;
